//external
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableAction from 'components/v2/tableAction';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
//internal
import { startRequest, finishRequest } from 'store/modules/loading/actions';
import ContentPanel from 'components/ContentPanel';
import { getAllows, getNutrientGroups } from 'services/nutrientGroup/service';
import { setMessage } from 'store/modules/message/action';
import { sanitizeErrorUI } from 'utils/errorUtil';
import DataTableReact from 'components/v2/dataTableReact';
import GridContainer from 'components/v2/grid';
import InputText from 'components/v2/inputText';
import { useDebounce } from 'utils/uiUtils';
import { FilterNutrientGroup } from '..';
//styled
import { IconContainer } from 'pages/nutrient/list/styled';

export default function NutrientGroup() {
  const message = useSelector(state => state.message.data);
  const [reload, setReload] = useState(0);
  const [dataNutrientGroup, setDataNutrientGroup] = useState();
  const [allows, setAllows] = useState({});
  //pagination
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [sort, setSort] = useState();

  const { filter, setFilter } = useContext(FilterNutrientGroup);

  const debouncedSearchNutrientGroup = useDebounce(filter.search);

  const dispatch = useDispatch();

  const columns = [
    {
      name: 'Descrição',
      selector: 'description',
      sortable: true,
    },
    {
      name: 'Ordem',
      selector: 'order',
      sortable: true,
    },
    {
      style: {justifyContent: "flex-end"},
      cell: row => 
        <div>
          <IconContainer>
            <TableAction 
            title={"Editar"} 
            disabled={!allows.put} 
            to={`/premixlabel/nutrient_group/edit/${row.id}`}>
              <EditIcon/>
            </TableAction>
            <TableAction 
            title={"Excluir"} 
            disabled={!allows.delete} 
            to={`/premixlabel/nutrient_group/delete/${row.id}`}>
              <DeleteIcon/>
            </TableAction>
          </IconContainer>
        </div>
    }
  ]

  const actions = [
    <div style={{display: 'flex'}} key="actionsNutrientGroup">
      <TableAction 
      key='addNutrientGroup'
      title={"Adicionar"} 
      disabled={!allows.post} 
      to='/premixLabel/nutrient_group/add'>
        <AddIcon/>
      </TableAction>
      <TableAction 
      key='refresh'
      title={"Atualizar"} 
      onClick={refreshHandler}
      isLink={false}>
        <RefreshIcon/>
      </TableAction>
    </div>
  ];

  useEffect(() => {
    dispatch(startRequest());
    getNutrientGroups(debouncedSearchNutrientGroup, perPage, filter.page, sort).then(data => {
      setTotalRows(parseInt(data.headers['recordcount']));
      setDataNutrientGroup(data.data);
    }).catch(err => {
      dispatch(setMessage(sanitizeErrorUI(err)));
    }).finally(() => {
      dispatch(finishRequest());
    });
    dispatch(startRequest());
    getAllows().then(data => {
      setAllows(data.data)
    }).catch(err => {
      dispatch(setMessage(sanitizeErrorUI(err)));
    }).finally(() => {
      dispatch(finishRequest());
    });
  }, [dispatch, reload, perPage, filter.page, sort, debouncedSearchNutrientGroup]);

  function refreshHandler() {
    setReload(reload + 1);
  }
   
  const handlePerRowsChange = (perPage) => {
    setPerPage(perPage);
  };

  const handlePageChange = (page) => {
    setFilter({...filter, page});
  };

  const handleSort = (column, sortDirection) => {
    setSort(`${column.selector} ${sortDirection}`);
  };
  
  return (
    <ContentPanel title="Grupo de Nutriente" message={message} actions={actions}>
      <GridContainer>
        <InputText
          xs={12}
          name="name"
          label="Pesquisar"
          type="text"
          placeholder="Pesquisar"
          value={filter.search}
          onChange={(e) => setFilter({page: 1, search: e.target.value})}
          hasWarning={false}
        />
      </GridContainer>
      <DataTableReact
        noHeader
        columns={columns}
        data={dataNutrientGroup}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        sortServer
        onSort={handleSort}
        paginationDefaultPage={filter.page}
      />
    </ContentPanel>
  )    
}